export default "__VITE_ASSET__CTDoxtRm__"